import { useState, useCallback, useMemo, useContext } from 'react';
import './pane-right.scss';
import TrafficLights from './pane-right-traffic-lights';
import PaneTasks from './pane-right-tasks';
import TaskItemDescription from './pane-right-task-description';
import Split from 'react-split';
import PaneMessages from './pane-right-messages';
import { TasksCounterProvider } from '../context/tasks-counter-context';
import { RecipientContext } from '../context/recipient-context';
import { ReadProvider } from '../context/read-context';

const PaneRight = () => {
    const [recipient, setRecipient] = useContext(RecipientContext);
    const [color, setColor] = useState(null);

    const handleTaskDescription = useCallback((taskID) => {
        setTaskID(taskID);
    }, [])

    const handleTrafficLightsChange = (color) => {
        setColor(color);
    };

    const [taskID, setTaskID] = useState(0);

    if (!recipient) return (
        <div className="messages-container">
            <div className="messages-traffic-lights-container">
                <TasksCounterProvider>
                    <TrafficLights handleTrafficLightsChange={handleTrafficLightsChange}></TrafficLights>
                </TasksCounterProvider>
            </div>

            <div className="split-container">
                <Split className="split" sizes={[50, 50]}>
                    <PaneTasks color={color} handleTaskDescription={handleTaskDescription}></PaneTasks>
                    <TaskItemDescription taskID={taskID}></TaskItemDescription>
                </Split>
            </div>

        </div>
    );

    return (
        <PaneMessages recipient={recipient}></PaneMessages>
    );
};

export default PaneRight;


